module.exports = __webpack_public_path__ + "static/img/n-alarm.764fcef7.png";